import { State } from 'model/State';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { getFromHamsClient } from 'util/mac/api/account/get';

export const isBtfAlreadyUsedForCMT = async (accountId: string, state: State) =>
  fetchWithParamValidation(({ id }) => getFromHamsClient(`/${id}/isBtfAlreadyUsedForCMT`, state), {
    id: accountId,
  });

export const manageAppLinkForBtfUnderCmt = async (accountId: string, state: State) =>
  fetchWithParamValidation(
    ({ id }) => getFromHamsClient(`/${id}/manageAppLinkForBtfUnderCmt`, state),
    {
      id: accountId,
    },
  );

export const siteNameWithDomainForBtfUnderCmt = async (accountId: string, state: State) =>
  fetchWithParamValidation(
    ({ id }) => getFromHamsClient(`/${id}/siteNameWithDomainForBtfUnderCmt`, state),
    {
      id: accountId,
    },
  );
